<template>
  <div class="product-container pt-5 position-relative vw-100">
    <transition
        appear
        v-bind:css="false"
        v-on:before-enter="actions.beforeEnterModal"
        v-on:enter="actions.enterModal"
        v-on:leave="actions.leaveModal"
    >
      <div class="product-instructions">
        <LocalizedLink to="/" class="close-detail position-absolute"></LocalizedLink>

        <arrow arrow-class="arrow-left" target="/grow-with-me"></arrow>
        <arrow arrow-class="arrow-right" target="/safety-element"></arrow>

        <div class="product-copy-container">
          <transition name="bounce">
            <div v-if="show">
              <div class="product-title">
                <div class="product-num">3</div>
                <div class="product-name" v-html="$t('audio_screen.title')"></div>
              </div>
              <div class="product-inst" v-html="$t('audio_screen.content')"></div>
            </div>
          </transition>
        </div>

      </div>
    </transition>
    <transition
        appear
        v-bind:css="false"
        v-on:before-enter="actions.beforeEnterProduct"
        v-on:enter="actions.enterProduct"
        v-on:leave="actions.leaveProduct"
    >
      <div class="product-detail position-absolute">
        <LargeNotes showNotes="one" class="music-note-container" />
        <LargeNotes showNotes="two" class="music-note-container-two" />
        <SoundWaves class="sound-wave-container" />
        <SoundWaves class="sound-wave-container-two" />

        <div class="detail-inner">
        <!-- <picture>
          <source media="(max-width: 414px)" :srcset="require('@/assets/imgs/product-two/sm-product.png')">
          <source media="(min-width: 415px)" :srcset="require('@/assets/imgs/product-two/product.png')"> -->
          <img class="product-img" :src="require('@/assets/imgs/product-two/product.png')">
        <!-- </picture> -->
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Arrow from "../Arrow";
import LocalizedLink from '@/components/LocalizedLink'
import LargeNotes from '@/components/particle/LargeMusicNotes.vue'
import SoundWaves from '@/components/particle/SoundWaves.vue'

import {inject} from "vue";

export default {
  name: "AudioAdventurePage",
  components: {
    Arrow,
    LocalizedLink,
    LargeNotes,
    SoundWaves
  },
  setup() {
    const store = inject("store");
    return {
      actions: store.actions
    };
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 800);
  }
}
</script>

<style lang="scss" scoped>
.product-detail {
  .detail-inner {
    .product-img {
      @media screen and (max-width: 728px) {
        width: 178%;
      }
    }
  }
}
.music-note-container {
    position: absolute;
    top: 27vh;
    left: 45vw;    
    transform: rotate(15deg) scale(1.2);
    z-index: 1;
    @media screen and (max-width: 768px) {
      top: 11vh;
      left: 28vw;
    }
    @media screen and (max-width: 414px) {
      top: 16vh;
      left: -3vw
    }
}
.music-note-container-two {
    position: absolute;
    top: 36vh;
    left: 55vw;
    transform: rotate(0) scale(1.2);
    z-index: 1;
    @media screen and (max-width: 768px) {
      top: 22vh;
      left: 51vw;
    }
    @media screen and (max-width: 414px) {
      top: 32vh;
      left: 39vw;
    }

}
.sound-wave-container {
  position: absolute;
  top: 56%;
  left: 63%;
  z-index: 1;
  width: 160px;
  transform: scale(0.4);
  @media screen and (max-width: 768px) {
    top: 27vh;
    left: 61vw;    
  }
  @media screen and (max-width: 414px) {
    top: 36vh;
    left: 65vw;
  }
}
.sound-wave-container-two {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  width: 160px;
  transform: scale(0.4) rotate(207deg);
  @media screen and (max-width: 768px) {
    top: 24vh;
    left: 44vw;
  }
  @media screen and (max-width: 414px) {
    top: 32vh;
    left: 38vw;
  }
}
</style>
